export default function ServicesSection() {
  const services = [
    {
      number: '01',
      title: 'Technical Engineering',
      subtitle: 'Проектирование и Стройка',
      description: 'Профессиональный инжиниринг для тех, кто строит «на века».',
      items: [
        'Архитектура и Проектирование: Разработка эксклюзивных проектов частных вилл и промышленных объектов любой сложности',
        'Технический надзор: Экспертный подбор строительных материалов, контроль качества и соблюдения сроков',
        'Инженерное консультирование: Поддержка на всех этапах реализации — от котлована до ввода в эксплуатацию'
      ],
      icon: 'ri-draft-line'
    },
    {
      number: '02',
      title: 'Операции с Недвижимостью',
      subtitle: 'и Оценка',
      description: 'Помогаем купить актив по реальной рыночной цене, без переплат.',
      items: [
        'Экспертная оценка: Профессиональная оценка реальной стоимости недвижимости и земли перед покупкой',
        'Инвестиционный подбор: Поиск ликвидных объектов (земля, коммерция, жилье) с высоким потенциалом роста'
      ],
      icon: 'ri-home-4-line'
    },
    {
      number: '03',
      title: 'Юридическое оформление',
      subtitle: 'Для иностранных граждан',
      description: 'Снимаем бюрократические барьеры для нерезидентов Турции (в т.ч. граждан РФ).',
      items: [
        'Оформление TAPU: Полное сопровождение в получении права собственности (TAPU) на землю и недвижимость',
        'Легализация сделки: Услуги лицензированного переводчика и нотариуса',
        'Проверка чистоты: Аудит объекта на наличие обременений и долгов'
      ],
      icon: 'ri-file-text-line'
    }
  ];

  return (
    <section id="services" className="bg-[#F8F4E8] py-32">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="h-0.5 w-16 bg-[#D4745E]"></div>
            <div className="w-2 h-2 rounded-full bg-[#D4745E]"></div>
            <div className="h-0.5 w-16 bg-[#D4745E]"></div>
          </div>
          <h2 className="text-5xl font-bold text-[#2B2D42]" style={{ fontFamily: 'Playfair Display, serif' }}>
            Наши услуги
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-12 border border-gray-200 shadow-lg hover:shadow-2xl transition-all duration-300 relative group cursor-pointer"
            >
              {/* Icon */}
              <div className="w-18 h-18 rounded-full bg-gradient-to-br from-[#D4745E] to-[#E89580] flex items-center justify-center mb-8">
                <i className={`${service.icon} text-4xl text-white`}></i>
              </div>

              {/* Number Watermark */}
              <div className="absolute top-8 right-8 text-9xl font-light text-gray-100 select-none" style={{ fontFamily: 'Playfair Display, serif' }}>
                {service.number}
              </div>

              {/* Title */}
              <h3 className="text-2xl font-bold text-[#2B2D42] mb-2 relative z-10" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {service.title}
              </h3>
              <p className="text-lg font-semibold text-gray-600 mb-4" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {service.subtitle}
              </p>

              {/* Description */}
              <p className="text-sm leading-relaxed text-gray-600 mb-7" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {service.description}
              </p>

              {/* Items List */}
              <ul className="space-y-3.5">
                {service.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#D4745E] text-lg mt-0.5 flex-shrink-0"></i>
                    <span className="text-xs font-medium text-gray-700 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
